/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryDto } from '../../models/history-dto';
import { HistoryUpdateDto } from '../../models/history-update-dto';

export interface HistoryAdminControllerUpdateV1$Params {
  id: string;
      body: HistoryUpdateDto
}

export function historyAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: HistoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
  const rb = new RequestBuilder(rootUrl, historyAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HistoryDto>;
    })
  );
}

historyAdminControllerUpdateV1.PATH = '/api/v1/histories/admin/{id}';
